<template>
  <div class="over">
    <!-- TEMPERATURES CONTAINER -->
    <div
      id="temps"
      class="temp-wrapper noselect"
    >
      <div
        class="infoi"
        v-show="!this.getTempLoaded || !this.getTemperaturesList"
      >
        <h2 v-if="!this.getTemperaturesList && this.getTempLoaded">
          {{ $t("message.noDataInRange") }}...
        </h2>
        <h2 v-else>{{ $t("message.loading") }}...</h2>
      </div>
      <div class="main-wrap over-info">
        <h2>{{ $t("dataType.temperature") }}</h2>
        <p class="first-block">{{ $t("message.dataOfSelectedDevice") }}</p>
        <img
          @click="downloadTemperatures"
          class="download-btn"
          src="../../../../public/assets/download.svg"
        />
      </div>
      <div class="disp-trend-wrapper">
        <LinePlot
          :height="this.plotHeight"
          :traces="this.getTraces"
          xTitle="Time (Hr)"
          yTitle="Temperature (°C)"
          v-if="this.getSelectedSensor"
        />
      </div>
    </div>
  </div>
</template>
<script>
import LinePlot from "../../graphs/LinePlot.vue";
import download from "../../../helpers/download.js";
import { mapGetters, mapActions } from "vuex";
var mql = window.matchMedia("screen and (max-width: 1499px)");

export default {
  name: "temperatures-module",
  components: {
    LinePlot,
  },
  data () {
    return {
      loaded: false,
      firstExec: true,
      today: new Date(Date.now()).toLocaleString().split(",")[0],
      plotHeight: 400,
    };
  },
  methods: {
    ...mapActions("eventdetails", ["setDateRange", "setSelectedSensor"]),
    sensorSelected: function (value) {
      this.setSelectedSensor(value);
    },
    dateSelected: function (dateRange) {
      this.setDateRange(dateRange);
    },
    responsiveScreenHandler: function (e) {
      // Modifico l'attributo 'height' del grafico in base alla dimensione della finestra, vedere 'mql'
      if (e.matches) {
        this.plotHeight = 350;
      } else {
        this.plotHeight = 400;
      }
    },
    /* Scarico .CSV */
    downloadTemperatures () {
      if (this.getTempLoaded) {
        let events = this.getTemperaturesList.map(function (item) {
          return {
            eui: item.eui.substr(item.eui.length - 4),
            date: new Date(item.date).toLocaleString().replace(/,/g, ""),
            temp: item.temperature.toFixed(2),
          };
        });
        let headers = {
          eui: "Device",
          date: "Data (Locale)",
          temp: "Temperature (°C)",
        };
        let title = "Temperature " + this.getSelectedSensor.eui.substr(this.getSelectedSensor.eui.length - 4);
        download.exportCSVFile(
          headers,
          events,
          title
        )
      }
    }
  },
  computed: {
    ...mapGetters({
      getSelectedSensor: "eventdetails/getSelectedSensor",
      getDateRange: "eventdetails/getDateRange",
      getSensors: "structure/getSensors",
      getTempLoaded: "eventdetails/getTempLoaded",
      getDispLoaded: "eventdetails/getDispLoaded",
      getTemperaturesList: "eventdetails/getTemperaturesList",
    }),
    getTraces: function () {
      return [
        {
          uid: "34534sa",
          line: {
            color: "rgb(17, 205, 239)",
            width: 4,
          },
          mode: "lines",
          name: "Peaks Line",
          type: "scatter",
          connectgaps: true,
          x: this.getTemperaturesList
            ? this.getTemperaturesList.map((item) => new Date(item.date))
            : [],
          y: this.getTemperaturesList
            ? this.getTemperaturesList.map((item) => (item.temperature ? item.temperature.toFixed(2): null))
            : [],
          //y: this.getTemperaturesList ? this.getTemperaturesList.map(item => (item.temperature)): [],
          xaxis: "x",
          yaxis: "y",
          opacity: 0.9,
          textfont: {},
        },
      ];
    },
  },
  async mounted () {
    // Verifico la dimensione della finestra e aggiungo listener per gestire il ridimensionamento
    this.responsiveScreenHandler(mql);
    mql.addListener(this.responsiveScreenHandler);
  },
};
</script>
<style scoped>
.over {
  min-width: 1100px;
  width: 96vw;
  column-gap: 2%;
  display: grid;
  grid-template-columns: 49% 49%;
  margin-left: 2vw;
  margin-right: 2vw;
  z-index: 2;
}

.download-btn {
  cursor: pointer;
  grid-row: 1/3;
  height: 18px;
  justify-self: end;
  margin-right: 32px;
  background-color: rgb(33, 150, 243);
  padding: 10px;
  grid-column: 2;
  border-radius: 10px;
}

/* Tra 600 e 1499 */
@media all and (max-width: 1499px) and (min-width: 300px) {
  .over {
    width: 96vw;
    margin-left: 2vw;
    margin-right: 2vw;
  }
}

.temp-wrapper {
  position: relative;
  height: 490px;
  margin-top: 30px;
  background-color: rgb(45, 48, 65);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
}

/* Tra 600 e 1499 */
@media all and (max-width: 1499px) and (min-width: 300px) {
  .temp-wrapper {
    height: 430px;
  }
}

#temps {
  width: 100%;
  grid-row: 2;
  grid-column-start: 1;
  grid-column-end: 3;
}

#tx-trend {
  grid-row: 1;
  grid-column: 1;
}

#temp-trend {
  grid-row: 1;
  grid-column: 2;
}

.infoi {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
}
.infoi {
  z-index: 2;
  background-color: black;
  opacity: 0.7;
  border-radius: 10px;
}
.infoi > h2 {
  margin: auto;
}

.main-wrap {
  margin-top: 20px;
  display: grid;
  margin-left: 60px;
  grid-template-columns: max-content;
}
.over-info > h2 {
  font-size: 1em;
  color: white;
  margin-top: 0;
  margin-bottom: 0;
}
.over-info > p {
  font-size: 0.8em;
  margin-top: 0;
  margin-bottom: 0;
}
.over-info {
  text-align: left;
  position: relative;
}
</style>
